export const sections = [
  {
    id: "terms",
    title: "Terms",
    content: (
      <>
        Site user (hereinafter — User) — a person who has access to the site via
        the Internet and uses the site. A cookie is a file containing an
        identifier (a string of letters and numbers) that is sent by a web
        server to a web browser and stored by the browser. Subsequently, the
        identifier is sent back to the server each time the browser requests a
        web page from the server.
        <br />
        Personal data — information or a set of information about a natural
        person who is identified or can be specifically identified.
      </>
    ),
  },
  {
    id: "provisions",
    title: "General provisions",
    content: (
      <>
        The User’s use of the site means agreement with this Policy and the
        terms of processing of the User’s personal data.
        <br />
        In case of disagreement with the terms of the Policy, the User must stop
        using the site. This Policy applies only to the site. The site does not
        control and is not responsible for the sites of third parties to which
        the User can go through the links available on the site.
      </>
    ),
  },
  {
    id: "subject",
    title: "Subject of Policy",
    content: (
      <>
        This Policy establishes Unit Agency’s obligations regarding
        non-disclosure and ensuring the protection of confidentiality of
        personal data that the User provides to Unit Agency or when placing an
        Order.
      </>
    ),
  },
  {
    id: "purpose",
    title: "Purposes of collection of personal user information",
    content: (
      <>
        The collection of personal data on the Website can be done by the
        following methods:
        <ol>
          <li>Automatically through your use of the Website;</li>
          <li>Voluntarily by giving you personally.</li>
        </ol>
        The personal information you provide through the Unit Agency website
        will be used for the purposes specified in these policies or on the
        relevant pages of the website. Unit Agency may use your personal
        information for the following purposes:
        <ol>
          <li>
            Processing of applications and requests made by the user on the
            website;
          </li>
          <li>In order to ensure the security of this site.</li>
        </ol>
        If you have provided personal information for publication on Unit
        Agency, we will publish it. In other cases, we undertake to protect and
        not disclose the transmitted data in accordance with the privacy policy.
        <br />
        Without your express consent, Unit Agency will not share your personal
        information with any third-party company for direct marketing use by
        that or any other third-party company.
      </>
    ),
  },
  {
    id: "disclosure",
    title: "Disclosure of personal information",
    content: (
      <>
        We reserve the right to disclose your personal information:
        <ol>
          <li>In those cases in which the law requires us to do so;</li>
          <li>In connection with any current or future legal proceedings;</li>
          <li>
            To establish, exercise or protect our legal rights (including
            providing information to other parties to prevent fraud).
          </li>
        </ol>
      </>
    ),
  },
];
